import request from '@/utils/request'
import { ResponseData } from './modular'
import md5 from 'md5'

/**
 * @description: 获取登录验证码
 * @param {*}
 * @return {*}
 */
export const getLoginCode = () => {
  return request<ResponseData<any>>('/web/captcha', {
    method: 'POST',
    showLoading: false,
    needToken: false,
    header: {
      accept: 'application/json',
    },
  })
}

/**
 * @description: 获取注册验证码
 * @param {*}
 * @return {*}
 */
export const getRegisterCode = () => {
  return request<ResponseData<any>>('/web/captcha', {
    method: 'POST',
    showLoading: false,
    needToken: false,
    header: {
      accept: 'application/json',
    },
  })
}

/**
 * @description: 注册
 * @param {*}
 * @return {*}
 * 确认密码（前端进行MD5加密，格式：${用户名}加明文密码，然后MD5）
 */
export const postRegister = (data: any) => {
  // 获取用户设备信息
  const deviceInfo = uni.getSystemInfoSync()
  return request<ResponseData<any>>('/web/register', {
    method: 'POST',
    data: {
      ...data,
      password: md5(`${data.password}`),
      deviceId: deviceInfo.deviceId,
    },
    needToken: false,
  })
}

/**
 * @description: 登录
 * @param {*}
 * @return {*}
 */
export const postLogin = (data: any) => {
  // 获取用户设备信息
  const deviceInfo = uni.getSystemInfoSync()
  return request<ResponseData<any>>('/web/login', {
    method: 'POST',
    data: {
      ...data,
      password: md5(`${data.password}`),
      deviceId: deviceInfo.deviceId,
    },
    needToken: false,
  })
}

/**
 * @description: 获取用户信息
 * @param {*}
 * @return {*}
 */
export const getUserInfo = () => {
  return request<ResponseData<any>>('/web/profile', {
    method: 'GET',
  })
}

/**
 * @description: 退出登录
 * @param {*}
 * @return {*}
 */
export const postLogout = () => {
  return request<ResponseData<any>>('/user/setting/logout', {
    method: 'POST',
  })
}

/**
 * @description: 修改密码
 * @param {*} data.password 原密码
 * @param {*} data.newPassword 新密码
 * @return {*}
 */
export const postUpdatePassword = (data: any) => {
  return request<ResponseData<any>>('/web/changePassword', {
    method: 'POST',
    data: {
      password: md5(`${data.password}`),
      newPassword: md5(`${data.newPassword}`),
    },
  })
}

/**
 * @description: 修改资金密码
 * @param {*}
 * /web/changePayPassword
 */
export const postChangePayPassword = (data: any) => {
  return request<ResponseData<any>>('/web/changePayPassword', {
    method: 'POST',
    data: {
      oldPassword: md5(`${data.oldPassword}`),
      password: md5(`${data.password}`),
      passwordRepeat: md5(`${data.passwordRepeat}`),
    },
  })
}

/**
 * @description: 币链网络
 * @param {*}
 * @return {*}
 */
export const getCoinChainNetwork = () => {
  return request<ResponseData<any>>('/web/getLinkNetworkList', {
    method: 'GET',
  })
}

/**
 * @description: 获取所有货币
 * @param {*}
 * @return {*}
 */
export const getCoinList = () => {
  return request<ResponseData<any>>('/web/getCurrencies', {
    method: 'GET',
  })
}

/**
 * @description: 获取签到配置
 * @param {*}
 * @return {*}
 */
export const getCheckinConfig = () => {
  return request<ResponseData<any>>('/web/defaultAct', {
    method: 'GET',
  })
}

/**
 * @description: 玩家签到信息
 * @param {*}
 * @return {*}
 */
export const getPlayerCheckinInfo = () => {
  return request<ResponseData<any>>('/web/getPlayerCheckins', {
    method: 'GET',
  })
}

/**
 * @description: 玩家签到
 * @param {*}
 * @return {*}
 */
export const postPlayerCheckin = () => {
  return request<ResponseData<any>>('/web/checkin', {
    method: 'POST',
  })
}

/**
 * @description: 获取充值渠道
 * @param {*}
 * @return {*}
 */
export const getDepositChannel = () => {
  return request<ResponseData<any>>('/web/getPayments', {
    method: 'GET',
  })
}

/**
 * @description: 获取提现渠道
 * @param {*}
 * @return {*}
 */
export const getWithdrawChannel = () => {
  return request<ResponseData<any>>('/web/getBehalfsList', {
    method: 'GET',
  })
}

/**
 * @description: tg登录
 * @param {*}
 * @return {*}
 */
export const postTgLogin = (data: any) => {
  // 获取用户设备信息
  const deviceInfo = uni.getSystemInfoSync()
  return request<ResponseData<any>>('/web/loginByTgId', {
    method: 'POST',
    data: {
      ...data,
      deviceId: deviceInfo.deviceId,
    },
  })
}

/**
 * @description: 获取系统通知
 * @param {*}
 * @return {*}
 */
export const getSystemNotice = (data: any) => {
  return request<ResponseData<any>>('/web/getNotices', {
    method: 'GET',
    data,
  })
}

/**
 * @description: 获取轮播图
 * @param {*}
 * @return {*}
 * /web/getBanns
 */
export const getBannerList = () => {
  return request<ResponseData<any>>('/web/getBanns', {
    method: 'GET',
    data: {
      siteId: Number(import.meta.env.VITE_APP_SITE_ID),
    },
  })
}

/**
 * @description: 邮箱登录
 * @param {*}
 * @return {*}
 */
export const postEmailLogin = (data: any) => {
  // 获取用户设备信息
  const deviceInfo = uni.getSystemInfoSync()
  return request<ResponseData<any>>('/web/loginByEmail', {
    method: 'POST',
    data: {
      ...data,
      password: md5(`${data.password}`),
      deviceId: deviceInfo.deviceId,
    },
    needToken: false,
  })
}

/**
 * @description: 邮箱注册
 * @param {*}
 * @return {*}
 */
export const postEmailRegister = (data: any) => {
  // 获取用户设备信息
  const deviceInfo = uni.getSystemInfoSync()
  return request<ResponseData<any>>('/web/registerByEmail', {
    method: 'POST',
    data: {
      ...data,
      password: md5(`${data.password}`),
      deviceId: deviceInfo.deviceId,
    },
    needToken: false,
  })
}

// /web/daily 完成每日活动
// /web/dailyBonusRecord 获取今日的每日活动记录
// /web/defaultAct 获取默认的活动配置(签到、每日)
